import { DataGrid } from "devextreme-react";
import {
  Column,
  Export,
  Paging,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";

export const ReviewJournalEntryExportSources = (props: any) => {
  const sources = props.data.data.sources.map((x: any) => {
    const t = x.transaction ?? {};
    const isPayment: boolean = x.isPayment;
    const customer = isPayment ? t.paymentCustomer : t.contributionCustomer;
    const constId =
      customer?.no ??
      t.paymentCustomer?.no ??
      t.contributionCustomer?.no ??
      t.orderCustomer?.no;
    const name =
      customer?.sortName ??
      t.paymentCustomer?.sortName ??
      t.contributionCustomer?.sortName ??
      t.orderCustomer?.sortName;
    const amount = t.transaction?.amount ?? 0;
    const transAmount = t.transaction?.amountSign === "N" ? -amount : amount;
    return {
      constId,
      name,
      postDate: t.posting?.date,
      postNo: t.posting?.no,
      batchNo: t.batch?.no,
      transactionType: t.transaction?.typeName,
      fundOrPayment: isPayment ? t.paymentMethod?.name : t.fund?.name,
      transAmount,
      transNo: t.transaction?.no,
      transSequenceNo: x.transactionSequenceNo ?? t.transaction?.sequenceNo,
    };
  });
  const calculateCustomSummary = (options: any) => {
    if (options.name !== "transactionTypes") {
      return;
    }
    if (options.summaryProcess === "start") {
      options.totalValue = new Set<string>();
    } else if (options.summaryProcess === "calculate") {
      if (options.value) {
        options.totalValue.add(options.value);
      }
    } else if (options.summaryProcess === "finalize") {
      options.totalValue = Array.from(options.totalValue as Set<string>).join(", ");
    }
  };
  return (
    <div>
      <h3>Transaction Sources</h3>
      <DataGrid
        dataSource={sources}
        showBorders={true}
        columnResizingMode="widget"
        columnMinWidth={50}
        columnAutoWidth={true}
      >
        <Export enabled={true} allowExportSelectedData={false} />
        <Paging enabled={false} />
        <Column dataField="constId" caption="Const ID" alignment="right" />
        <Column dataField="name" caption="Name" />
        <Column
          dataField="postDate"
          caption="Post Date"
          dataType="date"
          format="M/d/yyyy"
        />
        <Column dataField="postNo" caption="Post No" alignment="right" />
        <Column dataField="batchNo" caption="Batch No" alignment="right" />
        <Column dataField="transactionType" caption="Transaction Type" />
        <Column
          dataField="fundOrPayment"
          caption="Fund/Price Layer/Fee/Payment"
        />
        <Column
          dataField="transAmount"
          caption="Trans Amount"
          dataType="number"
          format={{ type: "fixedPoint", precision: 2 }}
          alignment="right"
        />
        <Column dataField="transNo" caption="Trans No" alignment="right" />
        <Column
          dataField="transSequenceNo"
          caption="Sequence No"
          alignment="right"
        />
        <Summary calculateCustomSummary={calculateCustomSummary}>
          <TotalItem
            column="constId"
            summaryType="count"
            displayFormat="Count: {0}"
          />
          <TotalItem
            name="transactionTypes"
            column="transactionType"
            showInColumn="name"
            summaryType="custom"
            displayFormat="Types: {0}"
          />
          <TotalItem
            column="transAmount"
            summaryType="sum"
            valueFormat={{ type: "fixedPoint", precision: 2 }}
            displayFormat="{0}"
          />
        </Summary>
      </DataGrid>
    </div>
  );
};
